import React, { useEffect, useState } from "react";

function useDialogActions() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };
  return { isDialogOpen, openDialog, closeDialog };
}

export default useDialogActions;
